/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const SettingsIcon = createIcon(
  '0 0 20 20',
  <path
    fillRule="evenodd"
    d="M14.5 2h-9L1 10l4.5 8h9l4.5-8zM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    clipRule="evenodd"
  />,
);
